export default __webpack_public_path__ + "static/media/MedVR_Logo.ce8c99ef.png";